// extracted by mini-css-extract-plugin
export default {"iconContainer":"Logo_iconContainer__mCmc9","defaultIcon":"Logo_defaultIcon__LwLkB","primary":"Logo_primary__cwT17","neshIcon":"Logo_neshIcon__3ojK7"};